import { Outlet, ScrollRestoration } from "react-router";
import { Stack, Grid } from "@mui/material";
import { pageLayout } from "@/theme/pageLayout";
import { useContractStatusSubscription } from "@/hooks/useContractStatusSubscription";
import Navigation from "@/components/app/Navigation/Navigation";
import SupportModeBanner from "@/components/app/SupportModeBanner";
import TrimbleFooter from "@/components/app/TrimbleFooter";
import useIdleLogout from "@/hooks/useIdleLogout";

const MainLayout = () => {
  useContractStatusSubscription();
  useIdleLogout();

  return (
    <Stack minHeight="100vh">
      <ScrollRestoration />
      <Navigation />
      <SupportModeBanner />
      <Grid
        container
        spacing={2}
        sx={pageLayout}
        paddingTop={5}
        paddingBottom={25}
        // flexGrow={1}
        flex={1}
      >
        <Outlet />
      </Grid>
      <TrimbleFooter />
    </Stack>
  );
};

export default MainLayout;
